
function FaqCard(probs) {

    return ( 
       <>
        <div className="accordion-item border-0 shadow-sm mb-3">
            <h2 className="accordion-header" id={"headingOne"}>
            <button className="accordion-button  text-white" type="button" data-bs-toggle="collapse" data-bs-target={"#collapseOne" + probs.id} aria-expanded="true" aria-controls="collapseOne">
               {probs.title}
            </button>
            </h2>
            <div id={"collapseOne" + probs.id}  className={probs.rank == 1 ? "accordion-collapse collapse show" : "accordion-collapse collapse"} aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
            <div className="accordion-body  text-dark">
            {probs.text}
            </div>
            </div>
        </div> 
    </> 
 ); 

}

export default FaqCard;